import createClient from "openapi-fetch";
import { transportFetch } from "@/lib/api";
import type { paths } from "./schema";

/*
 * Der typisierte API-Client. `paths` kommt aus `schema.d.ts` und damit aus der
 * OpenAPI-Spec des Backends — Pfade, Parameter und Antwortformen sind ab hier
 * keine Annahme mehr, sondern Vertrag.
 *
 * Das ist die Bruchstelle, die den ganzen Umbau begründet: benennt ein Go-DTO
 * ein Feld um, schlägt nach `pnpm codegen` der Frontend-Build fehl, statt dass
 * zur Laufzeit `undefined` durch die UI wandert.
 *
 * Zur `baseUrl`: Der `/api`-Präfix steckt bereits in den Spec-Pfaden
 * (`/api/health`, `/api/ready`) — hier darf er NICHT nochmal davor, sonst
 * entsteht `/api/api/health`. Die Basis ist deshalb nur die eigene Origin.
 *
 * Warum überhaupt eine Origin und nicht der leere String: `openapi-fetch` baut
 * intern ein `Request`-Objekt, und `new Request("/api/health")` verlangt eine
 * absolute URL. Im Browser löst der relative Pfad gegen `document.baseURI`
 * auf, außerhalb eines Dokuments (Node/undici, also auch die Tests) wirft er
 * `ERR_INVALID_URL`.
 *
 * Das bleibt die EIGENE Origin, kein fest verdrahteter Backend-Host: im Dev
 * :5173, wo der Vite-Proxy `/api` weiterreicht, in Prod die Origin, unter der
 * das Go-Binary SPA und API gemeinsam ausliefert. Eine Backend-Adresse steht
 * nach wie vor nirgends im Client-Code.
 */
export const api = createClient<paths>({
  baseUrl: window.location.origin,
  fetch: transportFetch,
  headers: { Accept: "application/json" },
});
